import React, { useRef, useState, useEffect } from 'react';
import { alert_error, alert_success } from "../AppContext.js";
import { Cookies } from '../index.js';
import AdSense from 'react-adsense';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Language_i18 from '../js/useNationalLanguage.jsx';

const TURNSTILE_SITE_KEY = '0x4AAAAAAASfVCWds84wnHvk';

const LoginUsername = ({ action }) => {
  // Lấy ngôn ngữ hiện tại từ Language_i18
  const { lang } = Language_i18();
    const national_market = Cookies.get('national_market');
  // Đối tượng dịch thuật cho giao diện người dùng
  const translations = {
    vi: {
      usernameLabel: "Tên đăng nhập",
      passwordLabel: "Password",
      usernamePlaceholder: "Nhập tên đăng nhập",
      passwordPlaceholder: "Nhập mật khẩu",
      signup: "Đăng ký",
      login: "Đăng nhập",
      confirmAgain: "Xác nhận lại",
      thankYou: "Thank you",
      pleaseWait: "Vui lòng đợi một lát 😊",
    },
    en: {
      usernameLabel: "Username",
      passwordLabel: "Password",
      usernamePlaceholder: "Enter username",
      passwordPlaceholder: "Enter password",
      signup: "Sign up",
      login: "Log in",
      confirmAgain: "Confirm again",
      thankYou: "Thank you",
      pleaseWait: "Please wait a moment 😊",
    }
  };

  // Khai báo trạng thái với tên biến tiếng Anh
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [buttonLabel, setButtonLabel] = useState('');
  const [actionText, setActionText] = useState('');
  const [actionType, setActionType] = useState('');
  const [authMode, setAuthMode] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [isProcessing, setIsProcessing] = useState(0);

  // Tham chiếu cho CAPTCHA
  const turnstileRef = useRef(null);
  const turnstileWidgetIdRef = useRef(null);

  // Hàm đặt lại CAPTCHA
  const resetCaptcha = () => {
    if (window.turnstile && turnstileWidgetIdRef.current !== null) {
      window.turnstile.reset(turnstileWidgetIdRef.current);
    }
    setCaptchaToken('');
  };

  // Xử lý thay đổi input
  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  // Hàm gọi API xác thực
  const authenticate = (url) => {
    const domain = window.location.hostname;
    const device_id = Cookies.get("device_id");
    const device_type = Cookies.get("device_type");

    axios.post(url, {
      username: username,
      password: password,
      clf_token: captchaToken,
      domain: domain,
      device_id: device_id,
      device_type: device_type,
      chedo: authMode,
      national_market: national_market
    })
      .then((response) => {
        if (response.data.status == 0) {
          resetCaptcha();
          setIsProcessing(0);
          alert_error(response.data.message);
          setButtonLabel(translations[lang]?.confirmAgain);
        } else if (response.data.status == 1) {
          setIsProcessing(0);
          alert_success(response.data.message);
          setButtonLabel(translations[lang]?.thankYou);
          const expirationDate = new Date();
          expirationDate.setFullYear(expirationDate.getFullYear() + 1);
          Cookies.set('apikey', response.data.apikey, { expires: expirationDate });
        } else {
          resetCaptcha();
          setIsProcessing(0);
          alert_error(response.data);
          setButtonLabel(translations[lang]?.confirmAgain);
        }
        if (response.data.redirect != null && response.data.redirect !== '') {
          setTimeout(() => {
            window.location.href = response.data.redirect;
          }, 1700);
        }
      })
      .catch((error) => {
        setIsProcessing(0);
        setButtonLabel(translations[lang]?.confirmAgain);
        alert_error(error);
      });
  };

  // Xử lý sự kiện gửi form
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsProcessing(1);
    setButtonLabel(translations[lang]?.pleaseWait);

    const url = actionType == 'signup' 
      ? 'https://hust.media/api/auth/signup.php' 
      : 'https://hust.media/api/auth/login.php';
    authenticate(url);
  };

  // Điều hướng trang
  const navigate = useNavigate();
  const navigateWithRefresh = (to) => {
    navigate(to, { state: { refresh: true } });
  };

  const switchAction = () => {
    if (actionType == 'signup') {
      navigateWithRefresh('/shop/auth/loginusername');
    } else {
      navigateWithRefresh('/shop/auth/signupusername');
    }
  };

  // Xử lý CAPTCHA thành công
  const ensureTurnstileScript = () => {
    return new Promise((resolve) => {
      if (window.turnstile) {
        resolve();
        return;
      }
      const existing = document.querySelector('script[data-cf-turnstile]');
      if (existing) {
        if (window.turnstile) {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.setAttribute('data-cf-turnstile', 'true');
      script.onload = () => resolve();
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    let cancelled = false;
    const initTurnstile = async () => {
      if (!turnstileRef.current) return;
      await ensureTurnstileScript();
      if (cancelled || !window.turnstile) return;
      if (turnstileWidgetIdRef.current === null) {
        turnstileWidgetIdRef.current = window.turnstile.render(turnstileRef.current, {
          sitekey: TURNSTILE_SITE_KEY,
          callback: (token) => setCaptchaToken(token),
          'expired-callback': () => setCaptchaToken(''),
          'error-callback': () => setCaptchaToken(''),
        });
      } else {
        window.turnstile.reset(turnstileWidgetIdRef.current);
      }
    };
    initTurnstile();
    return () => {
      cancelled = true;
    };
  }, [actionType]);

  // Cập nhật trạng thái ban đầu dựa trên action
  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const chedoValue = url.searchParams.get('chedo');

    if (action) {
      if (action.includes("signup")) {
        setButtonLabel(translations[lang]?.signup);
        setActionText(translations[lang]?.signup);
        setActionType('signup');
        if (chedoValue == 'native') {
          setAuthMode('native');
        }
      } else if (action.includes("login")) {
        setButtonLabel(translations[lang]?.login);
        setActionText(translations[lang]?.login);
        setActionType('login');
        if (chedoValue == 'native') {
          setAuthMode('native');
        }
      }
    }
  }, [action, lang]);

  return (
    <>
      {window.location.hostname == 'hust.media' && (
        <div className="max-h-16">
          <div className="cards">
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="1627514116"
              style={{ display: 'block' }}
              format='horizontal'
              responsive='false'
            />
          </div>
        </div>
      )}
      <div className="justify-center mx-auto py-3 px-3 items-center w-128 max-w-full mt-0">
        <div className="bg-[#f5f6fa] border-blue-400 border-2 rounded shadow p-4">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold mb-3">{actionText}</h2>
            </div>
            <div>
              <button 
                onClick={switchAction} 
                className="bg-blue-500 text-white py-2 px-4 rounded"
              >
                {actionType == 'signup' ? translations[lang]?.login : translations[lang]?.signup}
              </button>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="username" className="ml-2 block font-medium mb-1">
                {translations[lang]?.usernameLabel}
              </label>
              <input
                placeholder={translations[lang]?.usernamePlaceholder}
                type="text"
                id="username"
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
                value={username}
                onChange={handleUsernameChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="ml-2 block font-medium mb-1">
                {translations[lang]?.passwordLabel}
              </label>
              <input
                placeholder={translations[lang]?.passwordPlaceholder}
                type="password"
                id="password"
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
                value={password}
                onChange={handlePasswordChange}
                required
              />
            </div>
            {actionType && (
              <div className="mt-0 flex justify-center items-center">
                <div ref={turnstileRef} className="mx-auto" />
              </div>
            )}
            <div>
              <button
                disabled={isProcessing == 1}
                onClick={handleSubmit}
                className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
              >
                <div className="flex items-center justify-between flex-1">
                  {isProcessing == 1 && (
                    <div className="spinner-border" role="status"></div>
                  )}
                  <span className="text-xl font-medium text-white">
                    {buttonLabel}
                  </span>
                  <div className="text-xl">{'\u27A4'}</div>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginUsername;
